<template>
  <v-card flat class="conteneurLead" id="conteneurLead">
      <v-card-title class="primary white--text"  style="height: 52px;  padding: 0px;">
        <v-btn icon @click="cancelDialog()"><v-icon class="white--text">close</v-icon></v-btn>
        <div
          class="title tf_title_dialog"
        >
          {{ $t('Nouvel exemple') }}
        </div>
        <v-spacer></v-spacer>
        <v-btn
            :loading="loadingDialog"
            :disabled="loadingDialog"
            v-if="$vuetify.breakpoint.smAndDown"
            flat
            @click.native="submitExempleIntent"
            class="white--text"
        >{{ $t('add') }}</v-btn>
      </v-card-title>
      <v-card-text>
        <p v-if="modeExpert">
          <span class='body-1 font-italic'>{{$t('intentCode')}} :</span><br>
          <span class='body-2 font-weight-bold'>{{intentDialog.code}}</span>
        </p>
        <p v-if="modeExpert">
          <span class='body-1 font-italic'>{{$t('Description')}} :</span><br>
          <span class='body-2 font-weight-bold'>{{intentDialog.desc}}</span>
        </p>
        <v-textarea 
          :label="$t('sentence') + '*'" 
          v-model="newExemple"
          max="255"
          required
          hint="Exemple obligatoire"
        ></v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click.native="cancelDialog()">{{ $t('cancel') }}</v-btn>
        <v-btn
          :loading="loadingDialog"
          :disabled="loadingDialog"
          color="primary"
          flat
          @click.native="submitExempleIntent"
        >{{ $t('add') }}</v-btn>
      </v-card-actions>
  </v-card>
</template>

<script>

export default {
  props: {
    intentDialog: {
      type: Object,
      default: () => ({})
    },
    modeExpert: {
      type: Boolean,
      default: false
    },
    loadingDialog: {
      type: Boolean,
      default: false
    },
    botWorkspace: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      newExemple: ''
    }
  },
  mounted () {},
  updated () {},
  computed: {},
  methods: {
    cancelDialog () {
      this.$emit('closeDialog')
    },
    submitExempleIntent () {
      if (this.newExemple !== '') {
        this.$emit('addNewEx', this.newExemple)
      }
    }
  },
  watch: {
    loadingDialog (val, oldVal) {
      console.log('loadingDialog', val + ' - ' + oldVal)
      if (!this.loadingDialog) {
        // console.log('loadingDialog inactif')
        this.newExemple = ''
      }
    }
  },
  filters: {}
}
</script>

<style scoped>
  .tf_title_dialog {
    text-overflow: ellipsis;
    width: calc(100% - 180px);
    overflow: hidden;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/watcheezy/WzNewQuestionIntent.vue